import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';

import Header from './components/Header';
import Home from './pages/Home';
import Projets from './pages/Projets';
import VeilleTechno from './pages/VeilleTechno';
import JourneeType from './pages/JourneeType';
import Contact from './pages/Contact';
import Entreprise from './pages/Entreprise';
import ProjetDetail from './pages/ProjetDetail';

function App() {
  return (
    <Router>
      {/* Pour garder le header tout le temps affiché */}
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projets" element={<Projets />} />
        <Route path="/veille-techno" element={<VeilleTechno />} />
        <Route path="/journee-type" element={<JourneeType />} /> 
        <Route path="/projet/:id" element={<ProjetDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/entreprise" element={<Entreprise />} />
      </Routes>
    </Router>
  );
}

export default App;
